import store from '@store';

export const setLabels = function (value){
	return transformLangKeys(value, Lang)
}
export const getOptions = function (optionsDeclaration){
	return transformLangKeys(store.getters['inputs/getLangKeys']({key: optionsDeclaration}), Lang);
}

export const getLangKey = function (optionsDeclaration, optionsIndex) {
	return transformLangKeys(store.getters['inputs/getLangKeys']({key: optionsDeclaration}), Lang)[optionsIndex];
}

export const getLangKeyByValue = function (optionsDeclaration, optionsIndex) {
	const langKeys = transformLangKeys(store.getters['inputs/getLangKeys']({key: optionsDeclaration}), Lang);
  const selectedOption = langKeys.find(option => option.value === optionsIndex);
  return selectedOption ? selectedOption : null;
}

function transformLangKeys (value, __) {
	if(value.length > 0) {
		value.forEach(function(item){
			if(item.hasOwnProperty('text')){
				item.text = __(item.text)
			}
			if(item.hasOwnProperty('label')){
				item.label = __(item.label)
			}
		}.bind(this))
		return value;
	} else {
		for (var key in value) {
			if(value[key].hasOwnProperty('text')){
				value[key].text = __(value[key].text)
			}
			if(value[key].hasOwnProperty('label')){
				value[key].label = __(value[key].label)
			}
		}
		return value;
	}
}
